module.exports = __webpack_public_path__ + "media/images/iconClose__accent-75f03364242278e583c8b58c1f6d307b.png";